import { Dispatch, ReactNode, SetStateAction } from "react";
import { Category } from "../../types/category";
import { SelectFormData } from "../../types/form";
import { UseFormReturn } from "react-hook-form";
import CategoryDragRow from "./categoryDragRow.comp";
import CategoryRow from "./categoryRow.comp";

export default function CategoryRows({
  groupedCats,
  draggingCat,
  setDraggingCat,
  dragToCat,
  setDragToCat,
  methods,
}: {
  groupedCats: Category[];
  draggingCat: Category | undefined;
  setDraggingCat: Dispatch<SetStateAction<Category | undefined>>;
  dragToCat: Category | undefined;
  setDragToCat: Dispatch<SetStateAction<Category | undefined>>;
  methods: UseFormReturn<SelectFormData, any>;
}) {
  return <>{renderRows(groupedCats, draggingCat, setDraggingCat, dragToCat, setDragToCat, methods)}</>;
}

function renderRows(
  groupedCats: Category[],
  draggingCat: Category | undefined,
  setDraggingCat: Dispatch<SetStateAction<Category | undefined>>,
  dragToCat: Category | undefined,
  setDragToCat: Dispatch<SetStateAction<Category | undefined>>,
  methods: UseFormReturn<SelectFormData, any>
) {
  var rows: ReactNode[] = [];

  rows.push(<CategoryDragRow key={`undefined_undefined`} parentId={undefined} afterId={undefined} />);

  for (const groupedCat of groupedCats.sort((a, b) => a.order - b.order)) {
    addRowsRecursive(0, rows, groupedCat, draggingCat, setDraggingCat, dragToCat, setDragToCat, groupedCats, methods);
  }

  return rows;
}

function addRowsRecursive(
  level: number,
  returnList: ReactNode[],
  current: Category,
  draggingCat: Category | undefined,
  setDraggingCat: Dispatch<SetStateAction<Category | undefined>>,
  dragToCat: Category | undefined,
  setDragToCat: Dispatch<SetStateAction<Category | undefined>>,
  siblings: Category[],
  methods: UseFormReturn<SelectFormData, any>
) {
  returnList.push(<CategoryRow key={current.id} indent={level} category={current} siblings={siblings} methods={methods} />);
  returnList.push(<CategoryDragRow key={`${current.parentId}_${current.id}`} parentId={current.parentId} afterId={current.id} />);

  if (current.children !== undefined && current.children.length > 0) {
    returnList.push(<CategoryDragRow key={`${current.id}_undefined`} parentId={current.id} afterId={undefined} />);

    for (var c of current.children.sort((a, b) => a.order - b.order)) {
      addRowsRecursive(level + 1, returnList, c, draggingCat, setDraggingCat, dragToCat, setDragToCat, current.children, methods);
    }
  }
}
